<template>
    <div>
        <action-bar>
            <router-link to="/settlements/create-request" class="btn btn-success">
                {{ $t('settlement.btn.add_settlement_request') }}
            </router-link>
        </action-bar>
        <kt-datatable v-bind="datatableProps" ref="datatable">
        </kt-datatable>
    </div>
</template>

<script>
    import {ApiUrl} from "@/common/api.service";
    import {AuthorizationHeader} from "@/common/jwt.service";
    import adminColumns from "./datatable/admin-queue-columns";
    import actionBar from "@/components/custom/action-bar";

    export default {
        components: {
            actionBar,
        },
        data() {
            return {
                query: {},
            };
        },
        computed: {
            datatableProps() {
                return {
                    id: "settlements_admin_queue_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('settlement/queue'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: (res) => {
                                    return res.data.data;
                                },
                                params: {
                                    query: this.query,
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: adminColumns,
                }
            },
        },
    }
</script>
